import { useParamsSearch } from '@anytag/shared-hooks';
import { TrendingInfluencersSearchFilterSchemaType } from '../schemaTypes';

export const useTrendingInfluencersFilter = () => useParamsSearch<TrendingInfluencersSearchFilterSchemaType>();
